/**************************************************
 * Nombre:       Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import fondo from '../../Recursos/fondo_anuncios.svg'
import personaje from '../../Recursos/personaje.png'
import {useContext, useEffect, useState} from "react";
import {irUrl} from "../../Utilidades/irUrl";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {contexApp} from "../../App";

const Anuncios = () => {
    const {sCell, sTab, masSM} = useResponsive()
    const cData = useContext(contexApp)
    const [anuncio, setAnuncio] = useState({})

    useEffect(() => {

        if (cData.anuncio && cData.anuncio.length > 0) {
            setAnuncio(cData.anuncio[0])
        }

    }, [cData])
    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            size={12}
        >

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                sx={{maxWidth: '1400px', px: 3,}}
                size={12}
            >


                <Grid item container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                        size={12}
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            backgroundImage: `url(${fondo})`,
                            p: sCell ? 2 : 6,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'center',
                            backgroundPosition: 'center',
                            pb: masSM ? 2 : 10
                        }}
                        spacing={masSM ? 2 : 0}

                    >

                        <Grid item container size={{xs: 12, sm: 5, md: 5}} sx={{justifyContent: 'flex-start'}}>
                            <img src={anuncio.img} width={sCell ? '100%' : '150%'} height={'auto'}
                                 style={{
                                     marginLeft: sCell ? 0 : -200,
                                     marginTop: sCell ? -120 : -125,
                                     marginBottom: sCell ? 0 : -150
                                 }}/>
                        </Grid>

                        <Grid item container size={{xs: 12, sm: 126, md: 6}}
                              sx={{justifyContent: 'flex-end', marginTop: sCell ? 2 : 0}}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                sx={{px: 2}}
                            >


                                <Grid item container size={12} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: '#fff',
                                        fontSize: 36,
                                        fontWeight: 800,
                                        lineHeight: 1.0,
                                        textAlign: sCell ? 'center' : 'left'
                                    }}>
                                        {anuncio.nombre}
                                    </Typography>
                                </Grid>


                                <Grid item container size={12}
                                      sx={{justifyContent: 'flex-start', marginTop: 2, zIndex: 2}}>
                                    <Typography sx={{
                                        color: '#fff',
                                        fontSize: 18,
                                        fontWeight: 400,
                                        textAlign: sCell ? 'center' : 'left',
                                        display: '-webkit-box',
                                        overflow: 'hidden',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: sCell ? 3 : 3,
                                        textOverflow: "ellipsis",

                                    }}>
                                        {anuncio.descripcion}
                                    </Typography>
                                </Grid>

                                <Grid item container size={12}
                                      sx={{
                                          justifyContent: sCell ? 'center' : 'flex-start',
                                          marginTop: sCell ? 8 : 1,
                                          marginBottom: anuncio && anuncio.link ? 0 : 6
                                      }}>

                                    <Button
                                        onClick={() => irUrl(anuncio.link)}
                                        color={'info'}
                                        sx={{
                                            color: theme.palette.primary.main,
                                            display: anuncio.link ? 'block' : 'none'
                                        }}
                                    >Más información</Button>

                                </Grid>

                                <Grid item container size={12}
                                      sx={{justifyContent: 'flex-end', zIndex: 1}}>
                                    {!sTab &&
                                        <img src={personaje} width={sCell ? 180 : 220} height={'auto'}
                                             style={{
                                                 marginBottom: sCell ? -80 : -16,
                                                 marginTop: sCell ? -80 : -170,
                                                 marginRight: sCell ? -32 : -108
                                             }}/>
                                    }
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Anuncios